<template>
  <ValidationObserver
    v-slot="{
      invalid
    }"
    :class="$style.containerNoSidebar"
    tag="div"
  >
    <PageContainer
      hasWideBreakpoint
    >
      <template v-slot:body>
        <Container
          v-if="showFeatureUsageSection"
        >
          <SectionFeaturesTrial
            :trialFeatures="activeFeatureUsage"
          />
        </Container>
        <Container>
          <NotificationInPage
            v-if="showPermissionsNotification"
            :notification="permissionsNote"
            @close="handleClosePermissionsNotification"
          />
          <SectionInsights
            v-model="orgSettings"
          />
          <SectionRemoteAssist
            v-if="showRemoteAssistSettings"
            :readonly="hasRemoteAssistSessionsScope"
            @changeRemoteAssistSettings="changeRemoteAssistSettings"
          />
          <LegalNotice />
        </Container>
      </template>
      <template v-slot:footer>
        <Container>
          <ButtonGroupSave
            :isDisabledPrimary="invalid || !enableMainAction"
            :isFullWidth="false"
            :isLoadingPrimary="loading"
            :secondaryButtonProps="$options.secondaryButtonProps"
            @primaryAction="handleSave"
            @secondaryAction="handleCancel"
          />
        </Container>
      </template>
    </PageContainer>
    <ModalUndoChanges
      :showModal="showModalUndo"
      @cancel="handleCloseModalUndo"
      @close="handleCloseModalUndo"
      @save="handleContinueUndo"
    />
  </ValidationObserver>
</template>

<script>
import {
  ButtonGroupSave, Container, NotificationInPage, PageContainer, Types,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { ValidationObserver } from 'vee-validate3';
import { mapGetters } from 'vuex';
import FeatureTrialsMixin from 'client/GrowthEngineering/utilities/FeatureTrialsMixin';
import LegalNotice from 'client/settings/components/LegalNotice.vue';
import ModalUndoChanges from 'client/settings/ModalUndoChanges.vue';
import SectionFeaturesTrial from 'client/settings/FeatureSettings/SectionFeaturesTrial.vue';
import SectionInsights from 'client/settings/FeatureSettings/SectionInsights.vue';
import SectionRemoteAssist from 'client/settings/FeatureSettings/SectionRemoteAssist.vue';
import SettingsMixin from 'client/settings/SettingsMixin';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

const permissionsNoteMsg = 'Some fields are disabled based on user role permissions.';

export default {
  name: 'FeatureSettingsPage',

  components: {
    ButtonGroupSave,
    Container,
    LegalNotice,
    ModalUndoChanges,
    NotificationInPage,
    PageContainer,
    SectionFeaturesTrial,
    SectionInsights,
    SectionRemoteAssist,
    ValidationObserver,
  },

  mixins: [
    FeatureTrialsMixin,
    SettingsMixin,
  ],

  data() {
    return {
      permissionsNote: new Types.NotificationConfig({
        icon: 'info',
        message: permissionsNoteMsg,
        title: '',
        type: 'informational',
        showCloseButton: true,
      }),
      showPermissionsNotification: false,
    };
  },

  computed: {
    ...mapGetters(settingsModule, [
      'hasRemoteAssistScope',
      'hasRemoteAssistSessionsScope',
    ]),

    showRemoteAssistSettings() {
      return (this.hasRemoteAssistScope || this.hasRemoteAssistSessionsScope)
      && this.$hasFeatureFlag(this.$featureFlags.remoteAssist);
    },
  },

  created() {
    this.fetchEntitledFeatureCodes();
    this.showPermissionsNotification = this.hasRemoteAssistSessionsScope;
  },

  methods: {
    handleClosePermissionsNotification() {
      this.showPermissionsNotification = !this.showPermissionsNotification;
    },
  },
};
</script>

<style module>
@import '../../components/PageLayouts/tabbedPageLayout.css';
@import '../settings.css';
</style>
